import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import enCommon from './locales/en/common.json';
import hiCommon from './locales/hi-IN/common.json';

export const i18n = i18next.createInstance();

await i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'hi-IN'],
    defaultNS: 'common',
    ns: ['common'],
    resources: {
      en: { common: enCommon },
      'hi-IN': { common: hiCommon },
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
